import React from 'react';

import { Arrow, ToggleLayer } from 'react-laag';

import Dropdown from '../Dropdown';
import PasswordRequirementContent from './PasswordRequirementContent';

function PasswordRequirementLayer({ children, values, show, tipOffset = 60 }) {
  return (
    <ToggleLayer
      renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
        show &&
        isOpen && (
          <div
            ref={layerProps.ref}
            className="layer"
            style={{
              ...layerProps.style,
              zIndex: 9999,
            }}
          >
            <Dropdown>
              <PasswordRequirementContent values={values} />
            </Dropdown>
            <Arrow
              style={{ ...arrowStyle, zIndex: '9' }}
              layerSide={layerSide}
              borderWidth={1}
              borderColor="rgba(0, 0, 0, 0.04)"
              backgroundColor="#fff"
              angle={40}
              roundness={0.5}
              size={12}
            />
          </div>
        )
      }
      placement={{
        anchor: 'RIGHT_TOP',
        triggerOffset: tipOffset,
      }}
    >
      {({ triggerRef, open }) => (
        <div ref={triggerRef} onFocus={open}>
          {children}
        </div>
      )}
    </ToggleLayer>
  );
}

export default PasswordRequirementLayer;
